import $ from 'jquery';

import { InventorySearchEvents } from './events';
import { GarageTool } from './garage/tool';

function setupCompareListeners() {
  const garage = GarageTool.default;

  // Adding-deleting a car from the list of compared on the inventory page
  // const $compareCheckboxes = $('input.compare-checkbox');
  const $compareCheckboxes = $(garage.checkboxSelector);
  if ($compareCheckboxes.length) {
    $compareCheckboxes.on('change', async function (e) {
      e.preventDefault();

      $(this).prop('disabled', true);

      const $checkbox = $(this);
      const vehicleID = $checkbox.data('garageToggleId');

      if (vehicleID) {
        if ($checkbox.is(':checked')) {
          await garage.add(vehicleID);
        } else {
          await garage.remove(vehicleID);
        }
      }

      $(this).prop('disabled', false);
    });
  }

  // Deleting a car from the list of compared vehicles on the page with compared cars
  //const $compareRemoveButtons = $('.compare .remove-btn');
  const $compareRemoveButtons = $(garage.removeButtonSelector);
  if ($compareRemoveButtons.length) {
    $compareRemoveButtons.on('click', async function (e) {
      e.preventDefault();
      $(this).prop('disabled', true);

      const $button = $(this);

      const vehicleID = $button.data('garageRemoveId');
      if (vehicleID) {
        await garage.remove(vehicleID);
      }

      $(this).prop('disabled', false);
    });
  }

  const $compareResetButton = $(garage.resetButtonSelector);
  if ($compareResetButton.length) {
    $compareResetButton.on('click', async function (e) {
      e.preventDefault();
      await garage.reset();
    });
  }
}

$(document).on(InventorySearchEvents.POST_RENDER, () => {
  setupCompareListeners();
});

setupCompareListeners();
